import { scrollElementLeft, scrollElementRight } from "../helpers";

export function initRelatedOffersComp(): void {
    const psfRelatedOffersContent = "#RelatedOffers .psf-related-offers-content";
    const psfRelatedOffersList = "#RelatedOffers .psf-related-offers__list";
  
    $(psfRelatedOffersList).off("scroll").on("scroll", (ev) => {
      const scrollLeft = $(psfRelatedOffersList)[0].scrollLeft ?? 0;
      const listWidth = $(psfRelatedOffersList)[0].scrollWidth ?? 0;
      const innerListWidth = $(psfRelatedOffersList).innerWidth() ?? 0;
  
      if (listWidth - innerListWidth == scrollLeft)
        $(psfRelatedOffersContent)
          .find(".psf-related-offers-control.psf-related-offers-control--right")
          .hide();
      else if (scrollLeft == 0)
        $(psfRelatedOffersContent)
          .find(".psf-related-offers-control.psf-related-offers-control--left")
          .hide();
      else
        $(psfRelatedOffersContent)
          .find(".psf-related-offers-control")
          .css({ display: "flex" });
    });
  
    $(
      "#RelatedOffers .psf-related-offers-control.psf-related-offers-control--right"
    )
        .off("click")
        .on("click", (ev) => {
            ev.preventDefault();
            scrollElementRight(psfRelatedOffersList, 344);
        });
    $(
      "#RelatedOffers .psf-related-offers-control.psf-related-offers-control--left"
    )
        .off("click")
        .on("click", (ev) => {
            ev.preventDefault();
            scrollElementLeft(psfRelatedOffersList, 344);
        });
}